import { render, staticRenderFns } from "./IconPanel.vue?vue&type=template&id=1d764422&scoped=true&"
import script from "./IconPanel.vue?vue&type=script&lang=js&"
export * from "./IconPanel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d764422",
  null
  
)

export default component.exports